const bank = process.env.BANK

const componentConfig = {
  vatEmail: {
    /*
            component: Registration.jsx
            route: /registration/vat-email
            */
    promotionalCode: {
      /**
       * Checks if the current bank supports entering a promotional code.
       *
       * @returns {boolean} - True if the current bank supports entering a promotional code, false otherwise.
       */
      isVisible: () => {
        const supportedBanks = ['NEXIBUSINESS'] // Banks that support promotional code entry
        return supportedBanks.includes(bank)
      }
    }
  },
  /*
            component: Consents.jsx
            route: /registration/consents
            */
  consents: {
    /**
     * Checks if consent pages must be displayed.
     *
     * @returns {boolean} - True if the current bank supports entering a promotional code, false otherwise.
     */
    isVisible: () => {
      const supportedBanks = ['NEXIBUSINESS'] // Banks that support promotional code entry
      return supportedBanks.includes(bank)
    }
  },
  securityCode: {
    /*
      component: SecurityCode.jsx
      route: /registration/security-code
    */
    radioboxSecurityCode: {
      isVisible: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      }
    }
  },
  regAttemptsExceededModal: {
    /*
      component: RegAttemptsExceededModal.jsx
    */
    descriptionChanged: {
      isVisible: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      }
    }
  }
}

export default componentConfig
